/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StoreEvidencePointWrite } from '../models/StoreEvidencePointWrite';
import type { StoreProfileUpdate } from '../models/StoreProfileUpdate';
import type { SuccessResponse_StoreEvidencePointList_ } from '../models/SuccessResponse_StoreEvidencePointList_';
import type { SuccessResponse_StoreEvidencePointRead_ } from '../models/SuccessResponse_StoreEvidencePointRead_';
import type { SuccessResponse_StoreProfileHistoryResponse_ } from '../models/SuccessResponse_StoreProfileHistoryResponse_';
import type { SuccessResponse_StoreProfileListResponse_ } from '../models/SuccessResponse_StoreProfileListResponse_';
import type { SuccessResponse_StoreProfileRead_ } from '../models/SuccessResponse_StoreProfileRead_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class StoreProfileService {
    /**
     * List Store Evidence Points Endpoint
     * @returns SuccessResponse_StoreEvidencePointList_ Successful Response
     * @throws ApiError
     */
    public static listStoreEvidencePointsEndpointApiV1StoreProfileStoreIdEvidencePointsGet({
        storeId,
    }: {
        storeId: number,
    }): CancelablePromise<SuccessResponse_StoreEvidencePointList_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/store-profile/{store_id}/evidence-points',
            path: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Store Evidence Point Endpoint
     * @returns SuccessResponse_StoreEvidencePointRead_ Successful Response
     * @throws ApiError
     */
    public static createStoreEvidencePointEndpointApiV1StoreProfileStoreIdEvidencePointsPost({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: StoreEvidencePointWrite,
    }): CancelablePromise<SuccessResponse_StoreEvidencePointRead_> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/store-profile/{store_id}/evidence-points',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Store Evidence Point Endpoint
     * @returns SuccessResponse_StoreEvidencePointRead_ Successful Response
     * @throws ApiError
     */
    public static updateStoreEvidencePointEndpointApiV1StoreProfileStoreIdEvidencePointsPointIdPut({
        storeId,
        pointId,
        requestBody,
    }: {
        storeId: number,
        pointId: number,
        requestBody: StoreEvidencePointWrite,
    }): CancelablePromise<SuccessResponse_StoreEvidencePointRead_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/store-profile/{store_id}/evidence-points/{point_id}',
            path: {
                'store_id': storeId,
                'point_id': pointId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Store Evidence Point Endpoint
     * @returns void
     * @throws ApiError
     */
    public static deleteStoreEvidencePointEndpointApiV1StoreProfileStoreIdEvidencePointsPointIdDelete({
        storeId,
        pointId,
        expectedVersion,
    }: {
        storeId: number,
        pointId: number,
        expectedVersion: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/store-profile/{store_id}/evidence-points/{point_id}',
            path: {
                'store_id': storeId,
                'point_id': pointId,
            },
            query: {
                'expected_version': expectedVersion,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Store Profiles Endpoint
     * GET /api/v1/store-profile — 门店档案列表 (RLS-scoped, 只读).
     * @returns SuccessResponse_StoreProfileListResponse_ Successful Response
     * @throws ApiError
     */
    public static listStoreProfilesEndpointApiV1StoreProfileGet({
        includeInactive = false,
    }: {
        /**
         * 老板/超管门店配置面可显式包含已停用门店
         */
        includeInactive?: boolean,
    }): CancelablePromise<SuccessResponse_StoreProfileListResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/store-profile',
            query: {
                'include_inactive': includeInactive,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Profile Endpoint
     * GET /api/v1/store-profile/{store_id} — 单店档案 (跨店 → 404, PIT-018 双层).
     * @returns SuccessResponse_StoreProfileRead_ Successful Response
     * @throws ApiError
     */
    public static getStoreProfileEndpointApiV1StoreProfileStoreIdGet({
        storeId,
    }: {
        storeId: number,
    }): CancelablePromise<SuccessResponse_StoreProfileRead_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/store-profile/{store_id}',
            path: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Store Profile Endpoint
     * PUT /api/v1/store-profile/{store_id} — 更新档案 (跨店写 → 403, PIT-018 双层).
     *
     * v1: 直写所有字段 (含敏感 monthly_rent / operation_type), 不阻塞审批; 敏感字段
     * change_log 打标 approval_ref=NULL (审批中台路由后续接, service 层 TODO)。
     * @returns SuccessResponse_StoreProfileRead_ Successful Response
     * @throws ApiError
     */
    public static updateStoreProfileEndpointApiV1StoreProfileStoreIdPut({
        storeId,
        requestBody,
    }: {
        storeId: number,
        requestBody: StoreProfileUpdate,
    }): CancelablePromise<SuccessResponse_StoreProfileRead_> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/store-profile/{store_id}',
            path: {
                'store_id': storeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Store Profile History Endpoint
     * GET /api/v1/store-profile/{store_id}/history — 变更历史 (跨店 → 404, PIT-018 双层).
     * @returns SuccessResponse_StoreProfileHistoryResponse_ Successful Response
     * @throws ApiError
     */
    public static getStoreProfileHistoryEndpointApiV1StoreProfileStoreIdHistoryGet({
        storeId,
    }: {
        storeId: number,
    }): CancelablePromise<SuccessResponse_StoreProfileHistoryResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/store-profile/{store_id}/history',
            path: {
                'store_id': storeId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
